import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const newsEventsCarousels = document.querySelectorAll(
    '.block-news-events .block-news-events__carousel'
  );

  if (0 < newsEventsCarousels.length) {
    newsEventsCarousels.forEach((newsEventsCarousel) => {
      const wrapper = newsEventsCarousel.closest(
        '.block-news-events__carousel-wrappers'
      );
      new Swiper(newsEventsCarousel, {
        slidesPerView: 1.15,
        spaceBetween: 20,
        navigation: {
          nextEl: wrapper.querySelector('.vtx-swiper__next'),
          prevEl: wrapper.querySelector('.vtx-swiper__prev'),
        },
        breakpoints: {
          768: {
            slidesPerView: 2.25,
            spaceBetween: 20,
          },
          1080: {
            slidesPerView: 3.15,
            spaceBetween: 20,
          },
        },
      });
    });
  }
});
